const ads = {
  home: {
    id: 'div-gpt-ad-1603332247483-0',
    path: '/164347972/G7_IS-MainSponsor-970x90',
    mapping: {
      0: [],
      960: [300, 100],
      1100: [900, 100]
    },
    sizes: [
      [300, 100],
      [900, 100]
    ]
  },
  tag: {
    id: 'div-gpt-ad-1607563912929-0',
    path: '/164347972/G7_IS-Tag_URL',
    mapping: {
      0: [],
      960: [300, 100],
      1100: [900, 100]
    },
    sizes: [
      [300, 100],
      [900, 100]
    ]
  },
  'editorial-Artigos': {
    id: 'div-gpt-ad-1607563718414-0',
    path: '/164347972/G7_IS-Editoria_Artigos',
    mapping: {
      0: [],
      960: [300, 100],
      1100: [900, 100]
    },
    sizes: [
      [300, 100],
      [900, 100]
    ]
  },
  'editorial-Tecnologia': {
    id: 'div-gpt-ad-1603332199107-0',
    path: '/164347972/G7_IS-Editoria_Tecnologia',
    mapping: {
      0: [],
      960: [300, 100],
      1100: [900, 100]
    },
    sizes: [
      [300, 100],
      [900, 100]
    ]
  },
  'editorial-Política': {
    id: 'div-gpt-ad-1603332137038-0',
    path: '/164347972/G7_IS-Editoria_Regulacao',
    mapping: {
      0: [],
      960: [300, 100],
      1100: [900, 100]
    },
    sizes: [
      [300, 100],
      [900, 100]
    ]
  },
  'editorial-Projetos': {
    id: 'div-gpt-ad-1603332058858-0',
    path: '/164347972/G7_IS-Editoria_Projetos',
    mapping: {
      0: [],
      960: [300, 100],
      1100: [900, 100]
    },
    sizes: [
      [300, 100],
      [900, 100]
    ]
  },
  'editorial-Mercado': {
    id: 'div-gpt-ad-1603331944561-0',
    path: '/164347972/G7_IS-Editoria_Mercado',
    mapping: {
      0: [],
      960: [300, 100],
      1100: [900, 100]
    },
    sizes: [
      [300, 100],
      [900, 100]
    ]
  },
  'editorial-Indicadores': {
    id: 'div-gpt-ad-1603331727233-0',
    path: '/164347972/G7_IS-Editoria_Indicadores',
    mapping: {
      0: [],
      960: [300, 100],
      1100: [900, 100]
    },
    sizes: [
      [300, 100],
      [900, 100]
    ]
  },
  'editorial-Podcasts': {
    id: 'div-gpt-ad-1603331988610-0',
    path: '/164347972/G7_IS-Editoria_Podcasts',
    mapping: {
      0: [],
      960: [300, 100],
      1100: [900, 100]
    },
    sizes: [
      [300, 100],
      [900, 100]
    ]
  },
  'random-1': {
    id: 'div-gpt-ad-1609272734951-0',
    path: '/164347972/G7_IS-Random_URL',
    mapping: {
      0: [],
      960: [300, 100],
      1100: [900, 100]
    },
    sizes: [
      [300, 100],
      [900, 100]
    ]
  },
  'random-2': {
    id: 'div-gpt-ad-1609255265778-0',
    path: '/164347972/G7_IS-Random2_URL',
    mapping: {
      0: [],
      960: [300, 100],
      1100: [900, 100]
    },
    sizes: [
      [300, 100],
      [900, 100]
    ]
  },
  'random-3': {
    id: 'div-gpt-ad-1609255875256-0',
    path: '/164347972/G7_IS-Random3_URL',
    mapping: {
      0: [],
      960: [300, 100],
      1100: [900, 100]
    },
    sizes: [
      [300, 100],
      [900, 100]
    ]
  },
  'random-4': {
    id: 'div-gpt-ad-1609255898788-0',
    path: '/164347972/G7_IS-Random4_URL',
    mapping: {
      0: [],
      960: [300, 100],
      1100: [900, 100]
    },
    sizes: [
      [300, 100],
      [900, 100]
    ]
  },
  'random-5': {
    id: 'div-gpt-ad-1609255924473-0',
    path: '/164347972/G7_IS-Random5_URL',
    mapping: {
      0: [],
      960: [300, 100],
      1100: [900, 100]
    },
    sizes: [
      [300, 100],
      [900, 100]
    ]
  },
  authors: {
    id: 'div-gpt-ad-1603332247483-0',
    path: '/164347972/G7_IS-MainSponsor-970x90', // TODO: #Main_970x90
    mapping: {
      0: [],
      960: [300, 100],
      1100: [900, 100]
    },
    sizes: [
      [300, 100],
      [900, 100]
    ]
  }
}

export default ads
